var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.719,
    y1: -0.281,
    x2: -0.877,
    y2: 1.526,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4a849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3b221"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-copy",
    "data-name": "Icon awesome-copy",
    className: "cls-1",
    d: "M20,28v2.5A1.5,1.5,0,0,1,18.5,32H1.5A1.5,1.5,0,0,1,0,30.5V7.5A1.5,1.5,0,0,1,1.5,6H6V24.5A3.5,3.5,0,0,0,9.5,28ZM20,6.5V0H9.5A1.5,1.5,0,0,0,8,1.5v23A1.5,1.5,0,0,0,9.5,26h17A1.5,1.5,0,0,0,28,24.5V8H21.5A1.5,1.5,0,0,1,20,6.5Zm7.561-1.939L23.439.439A1.5,1.5,0,0,0,22.379,0H22V6h6V5.621a1.5,1.5,0,0,0-.439-1.061Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f7118fd65c6047e976edfc4295ce102d.svg";
export { ForwardRef as ReactComponent };